<template>
  <view class="package-usage-item">
    <view class="package-usage-item-left">
      <view class="package-usage-item-left-title">{{ packDetail }}</view>
      <view class="package-usage-item-left-time">{{ showTime }}</view>
    </view>
    <view class="package-usage-item-right">{{ packNum }}</view>
  </view>
</template>

<script>
    import { createComponent } from '@didi/es-mpx-creator'
    import dayjs from 'dayjs'

    createComponent({
      props: {
        packageUsageItem: {
          type: Object,
          value: {
            detail: '抢票订单退回',
            create_time: '2023-07-21 15:12:12',
            number: '+11个'
          }
        }
      },
      computed: {
        packDetail() {
          return this.packageUsageItem?.detail ?? ''
        },
        showTime() {
          return dayjs(this.packageUsageItem.create_time).format('MM-DD HH:mm:ss')
        },
        packNum() {
          return this.packageUsageItem?.number ?? ''
        }
      },
      methods: {}
    })
</script>

<style scoped lang="stylus">
  .package-usage-item
    padding 12px
    box-sizing border-box
    display flex
    justify-content space-between
    align-items center
    box-sizing border-box
    background #F8F9FD
    border-radius 8px
    margin-bottom 8px
    &-left
      display flex
      flex-direction column
      justify-content space-between
      font-family PingFangSC-Medium
      font-weight 500
      font-size 14px
      line-height 16px
      letter-spacing 0px
      color #333
      &-time
        font-family PingFangSC-Regular
        font-weight 400
        font-size 10px
        line-height 10px
        letter-spacing 0px
        color #000
        margin-top 4px
    &-right
      font-family PingFangSC-Regular
      font-weight 400
      font-size 14px
      line-height 16px
      letter-spacing 0px
      color #333
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {}
    }
</script>